import { useCallback } from 'react';
import { useNavigate, type NavigateFunction, type NavigateOptions, type To } from 'react-router-dom';

import { sanitizeNavigateTarget } from '~/utils/safeNavigation';

/** Wraps react-router `navigate` to block open-redirect targets. */
export function wrapAppNavigate(navigate: NavigateFunction): NavigateFunction {
  const safeNavigate = ((to: To | number, options?: NavigateOptions) => {
    if (typeof to === 'number') {
      navigate(to);
      return;
    }

    if (options !== undefined) {
      navigate(sanitizeNavigateTarget(to), options);
      return;
    }

    navigate(sanitizeNavigateTarget(to));
  }) as NavigateFunction;

  return safeNavigate;
}

/** Drop-in replacement for `useNavigate` with open-redirect protection. */
export function useAppNavigate(): NavigateFunction {
  const navigate = useNavigate();
  return useCallback(wrapAppNavigate(navigate), [navigate]);
}
